// extracted by mini-css-extract-plugin
export default {"round-button":"round-button_round-button__mBr15","selected":"round-button_selected__MWKAp"};